import { observer } from 'mobx-react-lite';
import { Card } from 'components/cards/card';
import { CardThemeType } from 'components/cards/card-type';
import DialogWrapper, { DialogWrapperProps } from 'components/dialog-wrapper/dialog-wrapper';
import { useComponentContext } from '../lib';
import './standard-dialog-wrapper.scss';

const StandardDialogWrapper = observer<DialogWrapperProps>((props) => {
  const { id, children } = props;
  const context = useComponentContext();

  /*
    This is a bit of a hack as native HTML dialogs are being used so the dialogs remain in the DOM.
    So while the dialogs remain in the DOM, the content is only rendered when needed.
    In the future (phase 2), React state could be used for the HTML dialog open/close state to avoid this.

    React portal could be used to render the dialog content outside of the current DOM hierarchy or the
    overlay component could be used instead of using <dialog />
  */
  const display = context.dialogToDisplay === id;

  return (
    <DialogWrapper {...props}>
      {display && <Card backgroundType={CardThemeType.Light}>
        {children}
      </Card>}
    </DialogWrapper>
  );
});

export default StandardDialogWrapper;